import { useMemo, useState } from 'react';
const plans = [
    {
        id: '1',
        label: 'Monthly',
        monthlyPrice: { value: 19, currency: 'USD' },
        totalPrice: { value: 19, currency: 'USD' },
    },
    {
        id: '2',
        label: 'Annually ($180 per year)',
        monthlyPrice: { value: 15, currency: 'USD' },
        totalPrice: { value: 180, currency: 'USD' },
        savings: { value: 48, currency: 'USD' },
    },
];
export const usePlans = (initialPlanId) => {
    const [selectedPlanId, setSelectedPlanId] = useState(initialPlanId || plans[0]?.id);
    const selectedPlan = useMemo(() => plans.find((plan) => plan.id === selectedPlanId), [selectedPlanId]);
    return { plans, selectedPlan, setSelectedPlan: setSelectedPlanId };
};
